function getProductData(e) {
  const target = e[0];
  const productEl = target.closest('[data-track-product]');
  const productData = productEl.dataset.trackProduct;
  return {
    items: [productData ? JSON.parse(productData) : {}],
  };
}

export const clickEvents = {
  visitSocialMedia(element) {
    const socialNetwork = element.attr('data-social-network');
    const socialTarget = element.attr('href');

    window.dataLayer.push({
      event: 'visitSocialMedia',
      socialNetwork,
      socialTarget,
    });
  },

  contactClick(element) {
    const contactType = element.attr('data-contact-type');

    window.dataLayer.push({
      event: 'contactClick',
      contactType,
    });
  },

  customerLogout() {
    window.dataLayer.push({
      event: 'customerLogout',
    });

    window.dataLayer.push({
      event: 'account_logout',
    });
  },

  accountViewOrder() {
    window.dataLayer.push({
      event: 'account_view_order',
    });
  },

  accountUpdateAddress() {
    window.dataLayer.push({
      event: 'account_update_address',
    });
  },

  accountAddNewAddress() {
    window.dataLayer.push({
      event: 'account_add_new_address',
    });
  },

  selectNavMenuItem(e) {
    window.dataLayer.push({
      event: 'select_nav_menu_item',
      eventdetails: {
        clicktext: e[0].dataset.trackLink,
      },
    });
  },

  switchStore(e) {
    window.dataLayer.push({
      event: 'switch_store',
      eventdetails: {
        language: e[0].dataset.trackStore,
      },
    });
  },

  viewWishlist() {
    window.dataLayer.push({
      event: 'viewWishlist',
    });
  },

  selectCompleteLook(e) {
    const data = getProductData(e);
    window.dataLayer.push({
      event: 'select_complete_look',
      ecommerce: {
        ...data,
      },
    });
  },

  selectSizeGuide(e) {
    const data = getProductData(e);
    window.dataLayer.push({
      event: 'select_size_guide',
      ecommerce: {
        ...data,
      },
    });
  },

  selectDescription(e) {
    const data = getProductData(e);
    window.dataLayer.push({
      event: 'select_description',
      ecommerce: {
        ...data,
      },
    });
  },

  selectCareInstructions(e) {
    const data = getProductData(e);
    window.dataLayer.push({
      event: 'select_care_instructions',
      ecommerce: {
        ...data,
      },
    });
  },

  selectDeliveryInformation(e) {
    const data = getProductData(e);
    window.dataLayer.push({
      event: 'select_delivery_information',
      ecommerce: {
        ...data,
      },
    });
  },

  selectGiftMessage() {
    window.dataLayer.push({
      event: 'select_gift_message',
    });
  },
};

export const dispatchEvents = {
  switchStore(_, data) {
    const {storeCode} = data;

    window.dataLayer.push({
      event: 'switchStore',
      targetStore: storeCode,
    });
  },

  formSubmitNewsletter(e) {
    window.dataLayer.push({
      event: 'form_submit_newsletter',
      eventdetails: {
        formid: e.detail.formId,
      },
    });
  },

  giftWrapAdded() {
    window.dataLayer.push({
      event: 'addonProductAdded',
      addonProductName: 'Gift Wrap',
    });
  },

  giftWrapRemoved() {
    window.dataLayer.push({
      event: 'addonProductRemoved',
      addonProductName: 'Gift Wrap',
    });
  },

  customerLogin(_, data) {
    const {userId} = data;

    window.dataLayer.push({
      event: 'customerLogin',
      userId,
    });
  },

  registration(_, data) {
    const {userId} = data;

    window.dataLayer.push({
      event: 'registration',
      userId,
    });
  },

  customerAddressChange(_, data) {
    const {userId} = data;

    window.dataLayer.push({
      event: 'customerAddressChange',
      userId,
    });
  },
};

export const events = {
  ...dispatchEvents,
  ...clickEvents,
};
